<template>
  <div class="checkout">

    <div class="checkout-heading">
      <h2>{{ trans.text.checkout.checkout }}</h2>
      <p>{{ trans.text.checkout.paymentWarn }}</p>
    </div>

    <div class="checkout-form">

      <div class="checkout-form-row">
        <h4>{{ trans.text.checkout.accountData }}:</h4>
        <div :ref="'email'" class="inp-group">
          <label for="chk-email">E-Mail</label>
          <input
            id="chk-email"
            v-model="userEmail"
            class="inp-style inp-fw"
            disabled
            required
            type="text"
          >
        </div>

        <div :ref="'f_name'" class="inp-group">
          <label for="chk-name">{{ trans.text.checkout.nameLabel }}</label>
          <input
            id="chk-name"
            v-model="userFirstName"
            class="inp-style inp-fw"
            disabled
            required
            type="text"
          >
        </div>

        <div :ref="'l_name'" class="inp-group">
          <label for="chk-surname">{{ trans.text.checkout.surnameLabel }}</label>
          <input
            id="chk-surname"
            v-model="userLastName"
            class="inp-style inp-fw"
            disabled
            required
            type="text"
          >
        </div>

      </div>

      <div class="checkout-form-row">
        <h4>{{ trans.text.checkout.deliveryAddress }}:</h4>
        <div class="inp-group">
          <label :ref="'recipient'" for="chk-rec">{{ trans.text.checkout.recipientName }}</label>
          <input
            id="chk-rec"
            v-model="deliveryRecipient"
            class="inp-style inp-fw"
            disabled
            required
            type="text"
          >
        </div>

        <div class="inp-row inp-row--street">
          <div class="inp-group">
            <label :ref="'streetNo'" for="chk-street">{{ trans.text.checkout.streetNameAndNumber }}</label>
            <input
              id="chk-street"
              v-model="deliveryStreetNumber"
              class="inp-style inp-fw"
              disabled
              required
              type="text"
            >
          </div>

          <div class="inp-group">
            <label :ref="'flat'" for="chk-flat">{{ trans.text.checkout.flat }}</label>
            <input
              id="chk-flat"
              v-model="deliveryFlat"
              class="inp-style inp-fw"
              disabled
              required
              type="text"
            >
          </div>
        </div>

        <div class="inp-group">
          <label :ref="'zip'" for="chk-zip">{{ trans.text.checkout.zip }}</label>
          <input
            id="chk-zip"
            v-model="deliveryZip"
            class="inp-style inp-fw"
            disabled
            required
            type="text"
          >
        </div>

        <div class="inp-group">
          <label :ref="'town_name'" for="chk-town">{{ trans.text.checkout.city }}</label>
          <input
            id="chk-town"
            v-model="deliveryCity"
            class="inp-style inp-fw"
            disabled
            required
            type="text"
          >
        </div>

        <div class="inp-group">
          <label :ref="'state'" for="chk-state">{{ trans.text.checkout.state }}</label>
          <input
            id="chk-state"
            v-model="deliveryState"
            class="inp-style inp-fw"
            disabled
            required
            type="text"
          >
        </div>

        <div class="inp-group">
          <label :ref="'country_id'">{{ trans.text.checkout.country }}</label>
          <input
            v-model="deliveryCountry"
            class="inp-style inp-fw"
            disabled
            required
            type="text"
          >
        </div>
      </div>

      <div class="checkout-info">
        <ul>
          <li>{{ trans.text.checkout['productionStart'] }}: <b>{{ trans.text.checkout['productionDate'] }}</b></li>
          <li>{{ trans.text.checkout['forecastDeliveryDate'] }}: <b>{{ getDeliveryDate() }}</b></li>
        </ul>
      </div>

      <p class="checkout-text">{{ trans.text.checkout['worldWideShipping'] }}</p>
      <div class="checkout-price">
        <div class="item">
          <p><strong>{{ trans.text.checkout.subTotal }}</strong></p>
          <p>{{ $crConverter(subTotal / 100, 'EUR') }}</p>
        </div>
        <div class="item">
          <p>{{ trans.text.checkout.shipping }}</p>
          <p>{{ trans.text.checkout.free }}</p>
        </div>
        <div class="item result">
          <p>{{ trans.text.checkout.total }}</p>
          <p>{{ $crConverter(sum / 100, 'EUR') }}
            <span v-if="tax <= 0">{{ trans.text.checkout.tax }}</span>
            <span v-else>{{ taxPercent }}</span>
          </p>
        </div>
      </div>

      <div class="inp-groups inp-groups__checkout">
        <div class="inp-group">
          <input
            id="styled-checkbox-1"
            v-model="dataProtectionClause"
            class="inp-group__checkbox"
            type="checkbox"
          >
          <label for="styled-checkbox-1">
            <span class="checkbox"></span>
            <span>{{ trans.text.checkout['iHaveRead'] }}
              <a
                :href="`/${lang}/page/data-protection-basic-information-purchase`"
                target="_blank">{{ trans.text.checkout.data }}
              </a>
              {{ trans.text.checkout.clause }}
            </span>
          </label>
        </div>

        <div class="inp-group">
          <input
            id="styled-checkbox-3"
            v-model="terms"
            class="inp-group__checkbox"
            type="checkbox"
          >
          <label for=styled-checkbox-3>
            <span class="checkbox"></span>
            <span>{{ trans.text.checkout['iHaveRead'] }}
              <a
                :href="`/${lang}/page/general-terms-and-conditions-of-sale`"
                target="_blank">
                {{ trans.text.checkout.terms }}
              </a>.
            </span>
          </label>
        </div>

        <div class="inp-group">
          <input
            id="styled-checkbox-2"
            v-model="authorizing"
            class="inp-group__checkbox"
            type="checkbox"
          >
          <label for="styled-checkbox-2">
            <span class="checkbox"></span>
            <span>{{ trans.text.checkout['iAuthorize'] }}</span>
          </label>
        </div>
      </div>
    </div>

    <div class="checkout-controls with-margin">
      <button
        :class="{'is-disabled': isDisabled, 'btn-gray': isDisabled, 'btn-green': !isDisabled}"
        :disabled="isDisabled"
        class="btn btn-block btn-card_pay"
        @click.prevent="order('ecompay')">
        <span v-if="isLoading && paymentType === 'ecompay'">
            {{ trans.text.checkout['waitForCheckoutComplete'] }}
        </span>
        <span v-if="!isLoading && paymentType !== 'ecompay'">
          Complete checkout
        </span>
      </button>
    </div>

    <div v-if="false" class="checkout-controls with-margin">
      <button
        :class="{'is-disabled': isDisabled, 'btn-gray': isDisabled, 'btn-green black': !isDisabled}"
        :disabled="isDisabled"
        class="btn btn-block"
        @click.prevent="order('apple_pay_core')"
      >
        <span v-if="isLoading && paymentType === 'apple_pay_core'">
            {{ trans.text.checkout['waitForCheckoutComplete'] }}
        </span>
        <span v-if="!isLoading && paymentType !== 'apple_pay_core'">
          {{ trans.text.checkout['payByApple'] }}
          <span class="apple-ic"></span>
        </span>
      </button>
    </div>

    <div v-if="false" class="checkout-controls">
      <button
        :class="{'is-disabled': isDisabled, 'btn-gray': isDisabled, 'btn-green blue': !isDisabled}"
        :disabled="isDisabled"
        class="btn btn-block btn-paypal_pay"
        @click.prevent="order('paypal')">
         <span v-if="isLoading && paymentType === 'paypal'">
            {{ trans.text.checkout['waitForCheckoutComplete'] }}
        </span>
        <span v-if="!isLoading && paymentType !== 'paypal'">
            {{ trans.text.checkout['payByPayPal'] }}
          <span class="paypal-ic"></span>
        </span>
      </button>
    </div>

    <v-modal :body="modalBody" :options="modalOptions" :type="modalType"/>

    <div class="checkout-payment">
      <div class="ic pay1"></div>
      <div class="ic pay2"><span class="abs"></span></div>
      <div class="ic pay3"></div>
      <div class="ic pay4"></div>
      <div class="ic pay5"></div>
      <div class="ic pay6"></div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import Multiselect from 'vue-multiselect';

import Modal from './modals/Modal'

require('vue-multiselect/dist/vue-multiselect.min.css');
export default {
  props: ['lang', 'trans', 'payment', 'priceData'],
  name: "ManualCheckoutComponent",
  components: {Multiselect, Modal},
  data() {
    return {
      isLoading: false,
      paymentType: null,
      modalBody: '',
      modalType: '',
      modalOptions: null,
      tax: null,
      taxPercent: 21,
      inv_recipient: null,
      inv_flat: null,
      inv_streetNo: null,
      inv_zip: null,
      inv_state: null,
      inv_country_id: null,
      inv_town_name: null,
      deliveryAddressOptions: [
        {
          id: 1,
          title: this.trans.text.checkout['sameAsDeliveryAddress'],
        },
        {
          id: 2,
          title: this.trans.text.checkout['otherDeliveryAddress'],
        },
      ],
      dataProtectionClause: false,
      terms: false,
      authorizing: false,
      sum: null,
      subTotal: null,
    }
  },
  mounted() {
    this.tax = this.priceData['taxValue'];
    this.sum = this.priceData.total;
    this.subTotal = this.priceData.subTotal;

    if (this.priceData.taxPercent === 0) {
      this.taxPercent = 'VAT 0%'
    } else {
      this.taxPercent = 'VAT ' + this.priceData.taxPercent + '% included'
    }

    if (this.country !== undefined && this.country.tax.code === 'IGI') {
      this.taxPercent = 'IGI ' + this.priceData.taxPercent + '% included'

    }

    this.$root.$on('modalShow', (data) => {
      this.modalBody = data.text;
      this.modalType = data.type;
      this.modalOptions = data.options;
      setTimeout(() => {
        $("#" + this.modalType).show();
      }, 2);
    });
  },
  computed: {
    userEmail() {
      if (this.payment) {
        return this.payment.order.user.email
      }

      return '';
    },
    userFirstName() {
      if (this.payment) {
        return this.payment.order.user.f_name
      }
      return '';
    },
    userLastName() {
      if (this.payment) {
        return this.payment.order.user.l_name
      }
      return '';
    },
    deliveryRecipient() {
      if (this.payment) {
        return this.payment.order.delivery_address.recipient
          || (this.payment.order.user.f_name + this.payment.order.user.l_name)
      }
      return '';
    },
    deliveryStreetNumber() {
      if (this.payment) {
        return this.payment.order.delivery_address.streetNo
      }
      return '';
    },
    deliveryFlat() {
      if (this.payment) {
        return this.payment.order.delivery_address.flat || ''
      }
      return '';
    },
    deliveryZip() {
      if (this.payment) {
        return this.payment.order.delivery_address.zip
      }
      return '';
    },
    deliveryCity() {
      if (this.payment) {
        return this.payment.order.delivery_address.city.town_name || ''
      }
      return '';
    },
    deliveryState() {
      if (this.payment) {
        return this.payment.order.delivery_address.state || ''
      }
      return '';
    },
    deliveryCountry() {
      if (this.payment) {
        return this.payment.order.delivery_address.country.country_name || ''
      }
      return '';
    },
    country_id() {
      if (!this.country) {
        return null
      }
      this.country.id;
    },
    country() {
      this.payment.order.delivery_address.country;
    },
    isDisabled() {
      return !(!!this.authorizing) || !(!!this.dataProtectionClause) || !(!!this.terms) || this.isLoading;
    },
    showChooseAnotherOptionsButtons() {
      return !!this.cartItems && this.cartItems.filter(item => {
        return item.frame_number_deleted;
      }).length > 0
    }
  },
  methods: {
    ...mapActions(['ManualCheckout']),
    counting(parts) {
      let price = 0;
      for (let part of parts) {
        if (part.category.as_option === 1) {
          price += parseInt(part.price_out);
        }
      }
      return price;
    },
    getDeliveryDate() {
      let countries = [148, 242, 243];
      if (!this.country_id || this.country.tax.id !== 3 || countries.indexOf(this.country.id) !== -1) {
        return this.trans.text.checkout.deliveryDate
      }
      return this.trans.text.checkout.deliveryDateOthers

    },
    order(type) {
      this.isLoading = true
      this.paymentType = type
      let data = {
        order_id: this.payment.order.id,
        payment_id: this.payment.id,
        hash: this.payment.hash,
        type: type
      };

      this.ManualCheckout({
        path: this.$path,
        data: data
      }).then(result => {
        if (result.data.paymentLink) {
          location.href = result.data.paymentLink
        } else {
          alert('Something went wrong. try later.')
        }
      }).catch(error => {
        console.log(error)
        alert('Something went wrong. try later.')
      }).finally(() => {
        this.isLoading = false;
        this.paymentType = null;
      })
    }
  }
}
</script>

<style scoped>
.btn {
  font-size: 20px;
}

.apple-ic,
.paypal-ic {
  margin-top: -2px;
}

.btn-gray .apple-ic,
.btn-gray .paypal-ic {
  opacity: .5;
}

.btn-gray {
  height: 54px;
}
</style>
<style lang="scss">
.multiselect__content-wrapper {
  overflow-x: hidden !important;
}

.with-margin {
  margin-bottom: 15px;
}

.no-hover {
  &:hover {
    color: #efefef;
    background: rgba(0, 0, 0, .5);
  }
}

.error-text {
  padding-top: 7px;
  color: #ff2207;
}

@media (max-width: 767px) {
  .checkout {
    padding-left: 24px;
    padding-right: 24px;
    box-sizing: border-box;
    max-width: 410px;
  }
}

</style>
